import React from "react";
import { Box } from "@mui/material";
import {
  MyTimeGeneralSettingsCard,
  MyTimeTimePeriodSettingsCard,
} from "my-time/components";
import { OcPageSideMenu, OcPageTransition } from "oc/components";
import { useOcPageSideMenu } from "oc/hooks";
import { useOcIsMobile } from "oc/hooks/use-is-mobile";

const menuDef = [
  {
    id: "myTimeGeneralSettings",
    label: "OC_GENERAL_SETTINGS",
    roles: ["MyTime.admin"],
  },
  {
    id: "myTimeTimePeriodSettings",
    label: "MY_TIME_TIME_PERIOD_SETTINGS",
    roles: ["MyTime.admin"],
  },
];

export const MyTimeAdminSettingsPage = () => {
  const stateId = "myTimeSettingsPageMenuActiveItem";
  const { state: selectedItem } = useOcPageSideMenu({
    id: stateId,
    initialValue: menuDef[0].id,
  });

  const isMobile = useOcIsMobile();

  return (
    <OcPageTransition>
      <Box>
        <Box
          id="my-hr-admin-settings-title"
          height="80px"
          style={{ backgroundColor: "#cc0033" }}
          display="flex"
          flexDirection="row"
          alignItems="center"
          paddingLeft="14px"
        >
          <Box style={{ color: "white", fontSize: "24px" }}>MyTime</Box>
        </Box>
        <Box display="flex" flexDirection={isMobile ? "column" : "row"}>
          <OcPageSideMenu stateId={stateId} menuDef={menuDef} />
          <Box
            id="my-time-admin-settings"
            flexGrow={1}
            padding={isMobile ? "16px 0px" : "16px"}
          >
            {selectedItem === "myTimeGeneralSettings" && (
              <>
                <MyTimeGeneralSettingsCard isMobile={isMobile} />
              </>
            )}
            {selectedItem === "myTimeTimePeriodSettings" && (
              <>
                <MyTimeTimePeriodSettingsCard isMobile={isMobile} />
              </>
            )}
          </Box>
        </Box>
      </Box>
    </OcPageTransition>
  );
};

export default MyTimeAdminSettingsPage;
